// src/utils/jwt.js
//
// Lightweight, dependency-free JWT payload decoder.
//
// SECURITY NOTE: this does NOT verify the token signature. It exists purely
// to read the `exp` claim on the client so we can schedule proactive token
// refreshes at the right time. The backend must always independently
// verify every token it receives — never use this decode result for any
// authorization decision in the frontend.

export function decodeJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

// Returns ms-since-epoch when the token expires, or null if it can't be read.
export function getTokenExpiryMs(token) {
  const payload = decodeJwt(token);
  if (!payload?.exp) return null;
  return payload.exp * 1000;
}